module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray@3x-4a230ac246ab3c2d8225316affa3e3b7.png";